<template>
	<Form
		ref="role"
		:model="buffer"
		:rules="roleValidate"
		@submit.native.prevent="handleSubmit"
	>
		<FormItem label="Name" prop="display_name">
			<Input
				:disabled="!editable"
				placeholder="Role name"
				v-model="buffer.display_name"
			>
			</Input>
		</FormItem>

		<FormItem label="Description" prop="description">
			<Input
				:disabled="!editable"
				type="textarea"
				placeholder="Role Description"
				v-model="buffer.description"
			>
			</Input>
		</FormItem>

		<FormItem
			prop="canOwnAccounts"
			label="
			Can be assigned/own accounts?"
			><br />
			<i-switch
				:disabled="!editable"
				size="large"
				v-model="buffer.can_own_accounts"
			>
				<span slot="open">Yes</span>
				<span slot="close">No</span>
			</i-switch>
		</FormItem>

		<FormItem class="pt-5" v-if="editable">
			<Button
				class="float-right"
				:disabled="!saveEnabled"
				type="primary"
				@click="handleSubmit"
				:loading="saving"
				>Submit</Button
			>
			<Button
				:disabled="!saveEnabled"
				@click="handleReset"
				v-if="saveEnabled"
				>Reset</Button
			>
		</FormItem>
	</Form>
</template>
<script>
export default {
	props: {
		role: Object,
		loading: Boolean,
		editable: Boolean,
	},
	data() {
		return {
			hash: require("object-hash"),
			buffer: _.cloneDeep(this.role),
			saving: false,
			roleValidate: {
				display_name: [
					{
						required: true,
						message: "The name cannot be empty",
						trigger: "blur",
					},
				],
				canOwnAccounts: [],
				description: [],
			},
		};
	},
	watch: {
		role: {
			handler() {
				this.saving = false;
			},
			deep: true,
		},
	},
	computed: {
		saveEnabled() {
			if (this.saving) {
				return false;
			}
			return (
				this.hash(
					_.pick(this.buffer, [
						"display_name",
						"description",
						"can_own_accounts",
					])
				) !=
				this.hash(
					_.pick(this.role, [
						"display_name",
						"description",
						"can_own_accounts",
					])
				)
			);
		},
	},
	methods: {
		async handleSubmit() {
			let _this = this;
			this.$refs["role"].validate(async (valid) => {
				if (valid) {
					this.saving = true;
					this.$emit(
						"submit",
						_.pick(this.buffer, [
							"display_name",
							"description",
							"can_own_accounts",
						])
					);
				}
			});
		},
		handleReset() {
			this.buffer = _.cloneDeep(this.user);
		},
	},
};
</script>
